/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2SosIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2SosIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2SosIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 22,
  height = 16,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2SosIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 22 16"
 style={{'--as-1-2rg4s9': alignSelf,'--mt-2-2rg4s9': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2rg4s9': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2rg4s9': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2rg4s9': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2rg4s9': opacity,'--w-10-2rg4s9': typeof width === 'number' ? `${width}px` : width,'--h-11-2rg4s9': typeof height === 'number' ? `${height}px` : height,'--f-12-2rg4s9': fill,'--a-7-2rg4s9': isAnimated ? animation : "none",'--sd-8-2rg4s9': isAnimated ? strokeDashoffset : 0,'--sd-9-2rg4s9': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2SosIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.52 6.347A2.347 2.347 0 013.867 4h1.155a2.504 2.504 0 012.365 1.672 1.015 1.015 0 01-1.914.676.477.477 0 00-.451-.318H3.867a.317.317 0 00-.068.627l1.759.385A2.508 2.508 0 015.022 12h-.995c-1.093 0-2.02-.7-2.365-1.672a1.015 1.015 0 011.914-.676.478.478 0 00.451.318h.995a.478.478 0 00.102-.945L3.365 8.64A2.347 2.347 0 011.52 6.347zm12.934 0A2.347 2.347 0 0116.802 4h1.155a2.504 2.504 0 012.364 1.672 1.015 1.015 0 11-1.913.676.478.478 0 00-.451-.318h-1.155a.317.317 0 00-.068.627l1.759.385A2.508 2.508 0 0117.957 12h-.995c-1.093 0-2.02-.7-2.364-1.672a1.015 1.015 0 011.913-.676.478.478 0 00.451.318h.995a.478.478 0 00.102-.945L16.3 8.64a2.347 2.347 0 01-1.846-2.293zm-4.437.16c0-.263.214-.477.478-.477h.995c.263 0 .477.214.477.477v2.986a.478.478 0 01-.478.477h-.995a.478.478 0 01-.477-.477V6.507zM10.495 4a2.507 2.507 0 00-2.508 2.507v2.986A2.507 2.507 0 0010.495 12h.995a2.507 2.507 0 002.507-2.507V6.507A2.507 2.507 0 0011.489 4h-.995z"
 style={{'--f-12-2rg4s9': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}